import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseComponent } from '../../component/app/base.component';

import { HospitalpatienreadimgComponent } from 'src/app/hospital/routes/patient/readimg.component';
import { ComponentsPlatVideoComponent } from '../../component/common/play-video.component';

@Component({
  selector: 'st-widget-imgs',
  template: `
    <nz-image-group>
      <div style="position: relative;display: inline-block;" class="mr-sm" *ngFor="let img of threeimgs; let i = index">
        <img
          nz-tooltip
          nzTooltipTitle="点击预览"
          *ngIf="img.type === '1'"
          class="patient-img"
          width="60px"
          height="60px"
          nz-image
          [nzSrc]="img.path"
          alt=""
        />
        <img
          nz-tooltip
          nzTooltipTitle="点击预览"
          *ngIf="img.type === '2'"
          class="patient-img"
          width="60px"
          height="60px"
          src="/assets/img/视频.png"
          alt=""
          (click)="playVideo(img)"
        />
        <img
          nz-tooltip
          nzTooltipTitle="点击下载"
          *ngIf="img.type === '3'"
          class="patient-img"
          width="60px"
          height="60px"
          src="/assets/img/文件.png"
          alt=""
          (click)="download(img)"
        />
        <!-- 超出3个img显示查看全部，给最后一个图片加上蒙层-->
        <span
          class="point"
          *ngIf="imgs.length > 3 && i === 2"
          [ngClass]="{ 'patient-img-lastimg': imgs.length > 3 && i === 2 }"
          (click)="show()"
          >查看全部</span
        >
      </div>
    </nz-image-group>
  `,

  styles: [
    `
      .patient-img {
        max-width: 60px;
        max-height: 60px;
        object-fit: cover;
      }
      .patient-img-lastimg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        line-height: 58px;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class STImgsWidget extends BaseComponent {
  static readonly KEY = 'imgs';

  imgs!: any[];
  get threeimgs() {
    if (this.imgs?.length > 3) {
      let item = this.imgs.slice(0, 3);
      return item;
    } else {
      return this.imgs;
    }
  }
  show() {
    this.modal.createStatic(HospitalpatienreadimgComponent, { imgs: this.imgs }).subscribe(res => {});
  }
  playVideo(mp4: any) {
    this.modal.createStatic(ComponentsPlatVideoComponent, { mp4: mp4.path }, { size: 400 }).subscribe(res => {});
  }
  download(item: any) {
    window.open(item.path);
  }
  // constructor(private msg: NzMessageService) { }
}
